import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { loginSSO } from '../services/Login/auth.service';
import { saveSsoLogin } from '../utils/Login/authStorage';

export default function SsoLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleSSOLogin = async () => {
      try {
        // Get encrypted employee ID from the URL
        const encryptedId = searchParams.get('eid');

        console.log('Encrypted ID from URL:', encryptedId);

        if (!encryptedId) {
          console.error('Encrypted employee ID not found in URL.');

          navigate('/login', {
            replace: true,
          });

          return;
        }

        // The Windows application has already encrypted
        // the employee code. Do not encrypt it again.
        const response = await loginSSO(encryptedId);

        console.log('SSO Login Response:', response);

        // Save token and employee details
        saveSsoLogin(response);

        // SSO login should always open Employee Dashboard
        navigate('/employee-dashboard', {
          replace: true,
        });
      } catch (error) {
        console.error('Automatic SSO login failed:', error);

        navigate('/login', {
          replace: true,
        });
      }
    };

    handleSSOLogin();
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="text-lg font-semibold text-slate-700">
          Signing you in...
        </div>

        <div className="mt-2 text-sm text-slate-500">
          Please wait while we authenticate your account.
        </div>
      </div>
    </div>
  );
}